module.exports = __webpack_public_path__ + "static/media/empathy-sympathy.3068bd86.svg";